import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    DataTableCardDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getSurfaceStyle
} from "../../../../helpers/theme/elevation";
import {
    getFocusRingStyle
} from "../../../../helpers/theme/state";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";
import {
    webStyle
} from "../../../../utils";

const stylesheet = StyleSheet.create({
    press: {
        ...StyleSheet.absoluteFill,
        ...webStyle({
            outlineStyle: "solid",
            cursor: "pointer",
            outlineWidth: 0
        })
    },
    header: {
        pointerEvents: "box-none",
        alignItems: "flex-start",
        flexDirection: "row"
    },
    fieldEnd: {
        alignItems: "flex-end"
    },
    fields: {
        pointerEvents: "none",
        flexDirection: "row",
        flexWrap: "wrap"
    },
    titles: {
        pointerEvents: "none",
        flexShrink: 1,
        flexGrow: 1,
        minWidth: 0
    },
    subtitle: {
        alignItems: "center",
        flexDirection: "row",
        flexWrap: "wrap"
    },
    surface: {
        alignSelf: "stretch"
    },
    amount: {
        fontVariant: [
            "tabular-nums"
        ]
    },
    field: {
        flexBasis: "40%",
        flexGrow: 1,
        minWidth: 0
    },
    action: {
        flexShrink: 0
    }
});

export const useStyles = ({
    isFocusVisible,
    shapeConfigs,
    shadowAlpha,
    elevations,
    isSelected,
    radiuses,
    borders,
    colors,
    spaces
}: DataTableCardDynamicStyleType) => {
    const styles = {
        surface: {
            ...getSurfaceStyle({
                surface: "card",
                shadowAlpha,
                elevations,
                borders,
                colors
            }),
            ...getCornerStyle({
                radius: radiuses.surface,
                shapeConfigs
            }),
            padding: spaces.spacingMd,
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>,
        fields: {
            columnGap: spaces.spacingMd,
            rowGap: spaces.spacingSm
        } as Mutable<ViewStyle>,
        subtitle: {
            columnGap: spaces.spacingXs
        } as Mutable<ViewStyle>,
        titles: {
            gap: spaces.spacingXxs
        } as Mutable<ViewStyle>,
        field: {
            gap: spaces.spacingXxs
        } as Mutable<ViewStyle>,
        header: {
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>
    };

    if(isSelected) {
        Object.assign(styles.surface, {
            backgroundColor: colors.content.container.selected,
            borderColor: colors.content.border.default,
            boxShadow: "none"
        });
    }

    Object.assign(styles.surface, getFocusRingStyle({
        isFocusVisible,
        borders,
        colors
    }));

    return styles;
};
export default stylesheet;
